import { PaginatedDiscussionGroupList } from '@goldcast/api/backend';

import { Room, Rooms, RoomCapacityOption } from './types';

export function transformServerRooms(rooms: Room[] | PaginatedDiscussionGroupList): Rooms {
  const transformedRooms: Record<number, Room> = {};
  Array.isArray(rooms) &&
    rooms.forEach((room: Room) => {
      const spots: string = room.capacity >= 1 ? `${room.capacity} seats` : `${room.capacity} seat`;
      room.spots = spots;
      transformedRooms[room.id] = room;
    });
  return transformedRooms;
}

export function separateByCommas(input: string): string[] {
  const trimmedInput = input.trim();
  const splitArray = trimmedInput.split(',');
  // Trim each element and remove any empty strings
  const resultArray = splitArray.map(item => item.trim()).filter(item => item !== '');

  return resultArray;
}

export function removeDuplicates(arr: string[]): string[] {
  const uniqueItems = Array.from(new Set(arr));
  return uniqueItems;
}

export function generateOptions(): RoomCapacityOption[] {
  const options: RoomCapacityOption[] = [];

  for (let i = 1; i <= 50; i++) {
    options.push({ value: i, label: i.toString() });
  }

  return options;
}
